import { axiosInstance } from "../axios/axiosConfig";
import { POPUP_API } from "../constants/api-constants";

export const getPopupAdsByPage = async (id) => {
  try {
    const response = await axiosInstance.get(`${POPUP_API.GET_POPUP_BY_PAGE}/${id}`);
    return response.data;
  } catch (error) {
    return null;
  }
};
